import type * as Types from '../../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCurrentUserQueryVariables = Types.Exact<{
  sensorName: Types.Scalars['String']['input'];
  platforms?: Types.InputMaybe<ReadonlyArray<Types.YalperPlatform> | Types.YalperPlatform>;
}>;


export type GetCurrentUserQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly currentCompany?: { readonly __typename?: 'AccountsCompany', readonly id: string, readonly badWords: ReadonlyArray<string>, readonly correctWords: ReadonlyArray<string>, readonly isClientAccess: boolean, readonly stopWords: ReadonlyArray<string>, readonly utmFormatMetrikaSettings: { readonly __typename?: 'YalperUtmFormatMetrikaSettings', readonly filterSources: ReadonlyArray<string | null>, readonly minVisits: number, readonly minVisitsForOldProblems: number }, readonly utmFormatAppsflyerWebdavSettings: { readonly __typename?: 'YalperUtmFormatAppsflyerWebdavSettings', readonly filterSources: ReadonlyArray<string | null> }, readonly geoGroups: ReadonlyArray<{ readonly __typename?: 'YalperGeoGroup', readonly name: string, readonly geos: ReadonlyArray<{ readonly __typename?: 'YalperGeo', readonly id: number, readonly name: string, readonly parentName: string }> }>, readonly stratLowConvSettings: { readonly __typename?: 'YalperStratLowConvSettings', readonly minConversions?: number | null, readonly periodDays?: number | null }, readonly regions: ReadonlyArray<{ readonly __typename?: 'YalperRegion', readonly id: number, readonly name: string }>, readonly exceptions: ReadonlyArray<{ readonly __typename?: 'YalperException', readonly id: string, readonly platform: Types.YalperPlatform, readonly items: ReadonlyArray<{ readonly __typename?: 'YalperExceptionItem', readonly field: string, readonly operator: Types.YalperExceptionOperator, readonly value: string }> }>, readonly exceptionFieldsets: ReadonlyArray<{ readonly __typename?: 'YalperExceptionFieldset', readonly platform: Types.YalperPlatform, readonly fields: ReadonlyArray<string> }>, readonly adDoubleSettings: { readonly __typename?: 'YalperAdDoubleSettings', readonly isMobileDouble?: boolean | null }, readonly utmCoherencySettings: { readonly __typename?: 'YalperUtmCoherencySettings', readonly skipParams: ReadonlyArray<string | null> }, readonly asKpiAgeGenderSettings: { readonly __typename?: 'YalperAsKpiAgeGenderSettings', readonly periodDays?: number | null }, readonly asKpiPlaceSettings: { readonly __typename?: 'YalperAsKpiPlaceSettings', readonly periodDays?: number | null }, readonly asKpiGeoSettings: { readonly __typename?: 'YalperAsKpiGeoSettings', readonly periodDays?: number | null }, readonly asMediaAdAnomalyGrowCpmSettings: { readonly __typename?: 'YalperAsMediaAdAnomalyGrowCpmSettings', readonly periodDays?: number | null, readonly comparisonMultiplierPercent?: number | null, readonly minAnalysisImpressions?: number | null, readonly minComparisonImpressions?: number | null }, readonly asCpmPlanExceededSettings: { readonly __typename?: 'YalperAsCpmPlanExceededSettings', readonly periodDays?: number | null, readonly minImpressions?: number | null, readonly planCpm: ReadonlyArray<{ readonly __typename?: 'YalperCampaignCpmItem', readonly campaignId: string, readonly cpm: number }> }, readonly asCampaignAnomalyFallVtrSettings: { readonly __typename?: 'YalperAsCampaignAnomalyFallVtrSettings', readonly periodDays?: number | null, readonly comparisonMultiplierPercent?: number | null }, readonly asAdAnomalyFallVisitDurationSettings: { readonly __typename?: 'YalperAsAdAnomalyFallVisitDurationSettings', readonly periodDays?: number | null, readonly comparisonMultiplierPercent?: number | null, readonly attributionModel?: Types.YalperAnalyticAttributionModelEnum | null }, readonly asAdAnomalyFallPageDepthSettings: { readonly __typename?: 'YalperAsAdAnomalyFallPageDepthSettings', readonly periodDays?: number | null, readonly comparisonMultiplierPercent?: number | null, readonly attributionModel?: Types.YalperAnalyticAttributionModelEnum | null, readonly minVisits?: number | null } } | null } | null };


export const GetCurrentUserDocument = gql`
    query GetCurrentUser($sensorName: String!, $platforms: [YalperPlatform!]) {
  currentUser {
    currentCompany {
      id
      badWords(sensorName: $sensorName)
      correctWords(sensorName: $sensorName)
      utmFormatMetrikaSettings(sensorName: $sensorName) {
        filterSources
        minVisits
        minVisitsForOldProblems
      }
      utmFormatAppsflyerWebdavSettings(sensorName: $sensorName) {
        filterSources
      }
      geoGroups {
        name
        geos {
          id
          name
          parentName
        }
      }
      stratLowConvSettings {
        minConversions
        periodDays
      }
      isClientAccess
      regions {
        id
        name
      }
      stopWords(sensorName: $sensorName)
      exceptions(sensorName: $sensorName, platforms: $platforms) {
        id
        platform
        items {
          field
          operator
          value
        }
      }
      exceptionFieldsets(sensorName: $sensorName) {
        platform
        fields
      }
      adDoubleSettings(sensorName: $sensorName) {
        isMobileDouble
      }
      utmCoherencySettings(sensorName: $sensorName) {
        skipParams
      }
      asKpiAgeGenderSettings(sensorName: $sensorName) {
        periodDays
      }
      asKpiPlaceSettings(sensorName: $sensorName) {
        periodDays
      }
      asKpiGeoSettings(sensorName: $sensorName) {
        periodDays
      }
      asMediaAdAnomalyGrowCpmSettings(sensorName: $sensorName) {
        periodDays
        comparisonMultiplierPercent
        minAnalysisImpressions
        minComparisonImpressions
      }
      asCpmPlanExceededSettings(sensorName: $sensorName) {
        periodDays
        planCpm {
          campaignId
          cpm
        }
        minImpressions
      }
      asCampaignAnomalyFallVtrSettings(sensorName: $sensorName) {
        periodDays
        comparisonMultiplierPercent
      }
      asAdAnomalyFallVisitDurationSettings(sensorName: $sensorName) {
        periodDays
        comparisonMultiplierPercent
        attributionModel
      }
      asAdAnomalyFallPageDepthSettings(sensorName: $sensorName) {
        periodDays
        comparisonMultiplierPercent
        attributionModel
        minVisits
      }
    }
  }
}
    `;

/**
 * __useGetCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserQuery({
 *   variables: {
 *      sensorName: // value for 'sensorName'
 *      platforms: // value for 'platforms'
 *   },
 * });
 */
export function useGetCurrentUserQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentUserQueryPage, GetCurrentUserQueryVariables> & ({ variables: GetCurrentUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
      }
export function useGetCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export function useGetCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export type GetCurrentUserQueryHookResult = ReturnType<typeof useGetCurrentUserQuery>;
export type GetCurrentUserLazyQueryHookResult = ReturnType<typeof useGetCurrentUserLazyQuery>;
export type GetCurrentUserSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserSuspenseQuery>;
export type GetCurrentUserQueryResult = Apollo.QueryResult<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>;